import { render, staticRenderFns } from "./VideoBackground.vue?vue&type=template&id=51889eff&scoped=true"
import script from "./VideoBackground.vue?vue&type=script&lang=js"
export * from "./VideoBackground.vue?vue&type=script&lang=js"
import style0 from "./VideoBackground.vue?vue&type=style&index=0&id=51889eff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51889eff",
  null
  
)

export default component.exports